import React from "react";
import { safeHref } from "shared/lib/sanitizer";

export default (props) => {
  const { style, value } = props;

  return <div><a style={style} href={safeHref(value)}>Visit link</a></div>;
}
